import * as yup from 'yup';

const changeSocialObjectValidationSchema = yup.object({
  type: yup
    .string()
    .required('Le type est requis.'),
  socialObject: yup
    .string()
    .required('Le nom de l\'objet social est requis.')
});

export default changeSocialObjectValidationSchema;
